<template>
  <permissions-view
    :site="site"
    :section="section"
  >
    <v-container>
      <v-form v-model="valid">
        <v-row>
          <v-col cols="3">
            <date-picker
              :readonly="isReadOnly()"
              label="TSS done"
              :value="getValue(design, 'tss_done')"
              @input="setValue(design, 'tss_done', $event)"
            />
          </v-col>
          <v-col cols="3">
            <date-picker
              :readonly="isReadOnly()"
              label="TSSR delivered"
              :value="getValue(design, 'tssr_delivered')"
              @input="setValue(design, 'tssr_delivered', $event)"
            />
          </v-col>
          <v-col cols="3">
            <date-picker
              :readonly="isReadOnly()"
              label="TSSR approved"
              :value="getValue(design, 'tssr_approved')"
              @input="setValue(design, 'tssr_approved', $event)"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <date-picker
              :readonly="isReadOnly()"
              label="Main design ordered"
              :value="getValue(design, 'main_design_ordered')"
              @input="setValue(design, 'main_design_ordered', $event)"
            />
          </v-col>
          <v-col cols="3">
            <date-picker
              :readonly="isReadOnly()"
              label="Main design received"
              :value="getValue(design, 'main_design_received')"
              @input="setValue(design, 'main_design_received', $event)"
            />
          </v-col>
          <v-col cols="3">
            <date-picker
              :readonly="isReadOnly()"
              label="Main design approved"
              :value="getValue(design, 'main_design_approved')"
              @input="setValue(design, 'main_design_approved', $event)"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <date-picker
              :readonly="isReadOnly()"
              label="Consents on main design"
              :value="getValue(design, 'consents_main_design')"
              @input="setValue(design, 'consents_main_design', $event)"
            />
          </v-col>
        </v-row>
        <h2>Documents</h2>
        <documents :site="site" />
        <empty-space />
        <form-actions
          v-if="!isReadOnly()"
          :saved="saved"
          v-on:saveData="saveData"
        ></form-actions>
      </v-form>
    </v-container>
  </permissions-view>
</template>

<script>
  import DatePicker from '@/components/DatePicker'
  import ReactivityMixin from '@/mixins/Reactivity'
  import SiteDesignService from '@/services/site-design'
  import FormActions from '@/components/FormActions'
  import Documents from '@/views/sites/sections/design/Documents'
  import PermissionsView from '@/components/PermissionsView'
  import PermissionsMixin from '@/mixins/Permissions'
  import EmptySpace from '@/components/EmptySpace'

  export default {
    name: 'Design',
    components: { EmptySpace, PermissionsView, Documents, FormActions, DatePicker },
    mixins: [
      ReactivityMixin,
      PermissionsMixin,
    ],
    props: {
      site: {
        default: null,
      },
      active: {
        default: false,
      },
    },
    data: () => ({
      saved: false,
      valid: false,
      design: null,
      section: 'design',
    }),
    mounted () {
      this.fetchData()
    },
    methods: {
      fetchData () {
        const ls = new SiteDesignService(this.site.id)
        ls.getSingle().then((response) => {
          this.design = response.data.data
          if (Array.isArray(this.design)) {
            this.design = {}
          }
        })
      },
      saveData () {
        this.saved = false
        if (this.valid) {
          const ls = new SiteDesignService(this.site.id)
          ls.post(this.design).then((response) => {
            this.saved = true
          })
        }
      },
    },
  }
</script>

<style scoped>

</style>
